import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompletePayorsComponent } from './autocomplete-payors.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [AutocompletePayorsComponent],
  exports: [AutocompletePayorsComponent]
})
export class AutocompletePayorsModule { }



// WEBPACK FOOTER //
// ./src/app/utils/autocomplete-payors/autocomplete-payors.module.ts